import { combineReducers } from '@reduxjs/toolkit';

import { formTemplatesApi } from '~forms/actions/templates';
import { mergeFieldsApi } from '~forms/actions/mergeFields';
import { completedFormsApi } from '~forms/actions/completedForms';
import { formImagesApi } from '~forms/actions/formImages';
import formBuilderReducer from './formBuilderSlice';

export default combineReducers({
  formBuilder: formBuilderReducer,
});

export const formsApis = [formTemplatesApi, mergeFieldsApi, completedFormsApi, formImagesApi] as const;
